import { Game } from "./BlockBreaker";
Game.main();
